import React, { useState } from "react";
import axios from "axios";
import "../assets/style.css";
import "../assets/contact.css";

const Contact: React.FC = () => {
  const BASE = import.meta.env.VITE_LYRAZONE_BASE_URL;

  const [formData, setFormData] = useState({
    CoName: "",
    CoEmail: "",
    Mobile: "",
    CoSubject: "",
    CoMessage: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setLoading(true);

      const payload = {
        name: formData.CoName,
        email: formData.CoEmail,
        mobile: formData.Mobile,
        subject: formData.CoSubject,
        message: formData.CoMessage,
      };

      const response = await axios.post(`${BASE}/contact`, payload);

      alert(
        response.data.message || "Your enquiry has been sent successfully.",
      );

      setFormData({
        CoName: "",
        CoEmail: "",
        Mobile: "",
        CoSubject: "",
        CoMessage: "",
      });
    } catch (error: any) {
      console.error("Contact form error:", error);
      alert(
        error?.response?.data?.message ||
          "Failed to send enquiry. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div id="home-p" className="home-p pages-head4 text-center">
        <div className="container"></div>
      </div>

      <section id="contact-p1" className="contact-p1">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="contact-p1-cont">
                <h3>Contact our experienced team</h3>
                <div className="heading-border-light"></div>
              </div>
              <p>
                It’s confirmed that you would be inspired by the marketing of
                pictorial and text contents of any website when you find any
                technical solution on the internet.
                <br />
                <br />
                Don't worry, we are here and you are about to reveal your
                technical problem by filling in the following details and
                pressing the send button. Please don't waste your time and take
                an opinion from our experienced team.
              </p>
              <a
                href="https://wa.me/+60149936302?text=Hi,%0ADear Valued Customer!%0ANow you are connected with Lyra Zone Support Team%0AHow may I help you?"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-general btn-silver" role="button">
                  WhatsApp Now
                </button>
              </a>
            </div>
            <div className="col-md-4">
              <div className="contact-p1-cont2">
                <address className="address-details-f">
                  Suite 4.06, 4th Floor,
                  <br />
                  Menara KH, Jalan Sultan Ismail,
                  <br />
                  50250 Kuala Lumpur, Malaysia.
                  <br />
                  Phone: +60 3 2691 7067
                  <br />
                  Email:{" "}
                  <a href="mailto:support@lyrazone.com.my">
                    support@lyrazone.com.my
                  </a>
                </address>
                <ul className="list-inline social-icon-f top-data">
                  <li>
                    <a
                      href="https://www.facebook.com/profile.php?id=61553204526797&mibextid=kFxxJD"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="fa top-social fa-facebook"
                        style={{ height: 35, width: 35, lineHeight: "20px" }}
                      ></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/lyra-zone-solutions/posts/?feedView=all"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="fa top-social fa-linkedin"
                        style={{ height: 35, width: 35, lineHeight: "20px" }}
                      ></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UC4HuaQMMFnFcLRB3IirK-Sg"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="fa top-social fa-youtube"
                        style={{ height: 35, width: 35, lineHeight: "20px" }}
                      ></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-p2" id="contact-p2">
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="row con-form">
              <div className="col-md-4">
                <input
                  type="text"
                  name="CoName"
                  id="CoName"
                  placeholder="Full Name"
                  className="form-control"
                  value={formData.CoName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-4">
                <input
                  type="email"
                  name="CoEmail"
                  id="CoEmail"
                  placeholder="Email"
                  className="form-control"
                  value={formData.CoEmail}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  name="Mobile"
                  id="mobile"
                  placeholder="Mobile Number"
                  className="form-control"
                  value={formData.Mobile}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-12">
                <input
                  type="text"
                  style={{ marginTop: "10px" }}
                  name="CoSubject"
                  id="CoSubject"
                  placeholder="Subject"
                  className="form-control"
                  value={formData.CoSubject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-12">
                <textarea
                  className="form-control"
                  style={{ marginTop: "10px", fontSize: "11px" }}
                  id="CoMessage"
                  name="CoMessage"
                  placeholder="Write your message here"
                  value={formData.CoMessage}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-12 sub-but">
                <button
                  className="btn btn-general btn-silver"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Submit Your Enquiry"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>

      <div className="map-responsive">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.785719389529!2d101.70735051064726!3d3.151142953126955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc37d4d35bcd7d%3A0x56f4aae820daf723!2sMenara%20KH!5e0!3m2!1sen!2smy!4v1776947877729!5m2!1sen!2smy"
          width="600"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>
    </>
  );
};

export default Contact;
